(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onni-code-collection-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.onni-codev5');
    if (!root) return;
    const nav = root.querySelector('.onni-codev5-nav-in');
    if (!nav) return;
    // Woerter kommen lokalisiert aus data-Attributen (Liquid t-Filter), Fallback = DE
    const T = {
      product: root.dataset.tProduct || 'Produkt',
      products: root.dataset.tProducts || 'Produkte',
      item: root.dataset.tItem || 'Artikel',
      items: root.dataset.tItems || 'Artikel',
    };
    // Kundensegment "Bestandskunde": Nur-Neukunden-Kacheln (z. B. Tester-Sets) sind per CSS
    // kollabiert — Zaehler in den Gruppenkoepfen + Toolbar auf die sichtbaren Kacheln korrigieren.
    if (document.documentElement.dataset.onniSegment === 'bestand') {
      let totalVisible = 0;
      root.querySelectorAll('.onni-codev5-sec').forEach((sec) => {
        const items = [...sec.querySelectorAll('.onni-codev5-item')].filter(
          (i) => !i.querySelector('[data-onni-nur-neukunden="true"]')
        );
        totalVisible += items.length;
        const sets = items.filter((i) => i.classList.contains('is-set')).length;
        const singles = items.length - sets;
        sec.dataset.sets = sets;
        const el = sec.querySelector('.onni-codev5-count');
        if (el) {
          el.textContent = sets > 0
            ? `${singles} ${T.products} + ${sets} ${sets === 1 ? 'Set' : 'Sets'}`
            : `${items.length} ${items.length === 1 ? T.product : T.products}`;
        }
      });
      const tb = root.querySelector('.onni-codev5-toolbar span');
      if (tb) tb.textContent = `${totalVisible} ${totalVisible === 1 ? T.item : T.items}`;
    }

    const anchors = [...nav.querySelectorAll('a[href^="#"]')];
    const secs = anchors.map((a) => document.querySelector(a.getAttribute('href'))).filter(Boolean);
    const setsChip = nav.querySelector('[data-onni-sets-filter]');

    const mark = () => {
      if (root.classList.contains('onni-only-sets')) {
        anchors.forEach((a) => a.classList.remove('on'));
        return;
      }
      let i = secs.findIndex((s) => s.getBoundingClientRect().bottom > 150);
      if (i < 0) i = secs.length - 1;
      anchors.forEach((a, j) => a.classList.toggle('on', j === i));
    };

    if (setsChip) {
      const toggleSets = () => {
        const on = root.classList.toggle('onni-only-sets');
        setsChip.classList.toggle('on', on);
        const navEl = root.querySelector('.onni-codev5-nav');
        window.scrollTo({ top: navEl.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
        mark();
      };
      setsChip.addEventListener('click', toggleSets);
      setsChip.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSets(); }
      });
    }
    anchors.forEach((a) =>
      a.addEventListener('click', () => {
        root.classList.remove('onni-only-sets');
        if (setsChip) setsChip.classList.remove('on');
      })
    );
    addEventListener('scroll', mark, { passive: true });
    mark();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onni-code-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.onni-codev5');
    if (!root) return;
    const nav = root.querySelector('.onni-codev5-nav-in');
    if (!nav) return;
    // Woerter kommen lokalisiert aus data-Attributen (Liquid t-Filter), Fallback = DE
    const T = {
      product: root.dataset.tProduct || 'Produkt',
      products: root.dataset.tProducts || 'Produkte',
      item: root.dataset.tItem || 'Artikel',
      items: root.dataset.tItems || 'Artikel',
    };
    // Kundensegment "Bestandskunde": Nur-Neukunden-Kacheln (z. B. Tester-Sets) sind per CSS
    // kollabiert — Zaehler in den Gruppenkoepfen + Toolbar auf die sichtbaren Kacheln korrigieren.
    if (document.documentElement.dataset.onniSegment === 'bestand') {
      let totalVisible = 0;
      root.querySelectorAll('.onni-codev5-sec').forEach((sec) => {
        const items = [...sec.querySelectorAll('.onni-codev5-item')].filter(
          (i) => !i.querySelector('[data-onni-nur-neukunden="true"]')
        );
        totalVisible += items.length;
        const sets = items.filter((i) => i.classList.contains('is-set')).length;
        const singles = items.length - sets;
        sec.dataset.sets = sets;
        const el = sec.querySelector('.onni-codev5-count');
        if (el) {
          el.textContent = sets > 0
            ? `${singles} ${T.products} + ${sets} ${sets === 1 ? 'Set' : 'Sets'}`
            : `${items.length} ${items.length === 1 ? T.product : T.products}`;
        }
      });
      const tb = root.querySelector('.onni-codev5-toolbar span');
      if (tb) tb.textContent = `${totalVisible} ${totalVisible === 1 ? T.item : T.items}`;
    }

    const anchors = [...nav.querySelectorAll('a[href^="#"]')];
    const secs = anchors.map((a) => document.querySelector(a.getAttribute('href'))).filter(Boolean);
    const setsChip = nav.querySelector('[data-onni-sets-filter]');

    const mark = () => {
      if (root.classList.contains('onni-only-sets')) {
        anchors.forEach((a) => a.classList.remove('on'));
        return;
      }
      let i = secs.findIndex((s) => s.getBoundingClientRect().bottom > 150);
      if (i < 0) i = secs.length - 1;
      anchors.forEach((a, j) => a.classList.toggle('on', j === i));
    };

    if (setsChip) {
      const toggleSets = () => {
        const on = root.classList.toggle('onni-only-sets');
        setsChip.classList.toggle('on', on);
        const navEl = root.querySelector('.onni-codev5-nav');
        window.scrollTo({ top: navEl.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
        mark();
      };
      setsChip.addEventListener('click', toggleSets);
      setsChip.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSets(); }
      });
    }
    anchors.forEach((a) =>
      a.addEventListener('click', () => {
        root.classList.remove('onni-only-sets');
        if (setsChip) setsChip.classList.remove('on');
      })
    );
    addEventListener('scroll', mark, { passive: true });
    mark();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onni-creator-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.onni-cr').forEach(function (root) {
      /* Typ-Wahl: Kachel antippen -> passendes Tester-Set zeigen */
      var sets = root.querySelector('.onni-cr-sets');
      var kacheln = root.querySelectorAll('[data-onni-cr-typ]');
      if (sets && kacheln.length) {
        sets.classList.add('is-bereit');
        var waehle = function (typ, scrollen) {
          kacheln.forEach(function (k) {
            k.setAttribute('aria-pressed', k.getAttribute('data-onni-cr-typ') === typ ? 'true' : 'false');
          });
          var ziel = null;
          sets.querySelectorAll('[data-onni-cr-set]').forEach(function (s) {
            var an = s.getAttribute('data-onni-cr-set') === typ;
            s.classList.toggle('is-aktiv', an);
            if (an) { ziel = s; }
          });
          if (scrollen && ziel && window.matchMedia('(max-width: 749px)').matches) {
            var y = ziel.getBoundingClientRect().top + window.scrollY - 90;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        };
        kacheln.forEach(function (k) {
          k.addEventListener('click', function () { waehle(k.getAttribute('data-onni-cr-typ'), true); });
        });
        /* Deep Link: #sensitive oder #classic wählt direkt vor */
        var h = (location.hash || '').slice(1).toLowerCase();
        if (h === 'sensitive' || h === 'classic') { waehle(h, false); }
      }

      /* Code kopieren */
      root.addEventListener('click', function (e) {
        var knopf = e.target.closest('[data-onni-cr-kopie]');
        if (!knopf) { return; }
        var code = knopf.getAttribute('data-onni-cr-kopie');
        var fertig = function () {
          knopf.textContent = 'Kopiert';
          knopf.classList.add('is-kopiert');
          setTimeout(function () { knopf.textContent = 'Kopieren'; knopf.classList.remove('is-kopiert'); }, 2000);
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(fertig, function () {});
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onni-pills-submenu"] && !Shopify.designMode) return;
  try {
    

  const sub_container = document.querySelector('.onni-submenu-pills-container');

  if (sub_container) {

    /* ONNI 29.09.2026 Ada (Fix, Paavo-Freigabe ausstehend, nur Testtheme):
       Frueher wurde pathname+search per href*= gesucht. Mit ?utm_...= (oder
       ?preview_theme_id=) im Link passte kein href mehr, es gab keine aktive Pille.
       Jetzt zaehlt nur der Pfad, ohne Locale-Praefix (/en/...) und ohne
       Schraegstrich am Ende, verglichen mit dem Pfad jedes Pillen-Links. */
    const onniRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const onniPfad = function (pfad) {
      pfad = (pfad || '/').toLowerCase();
      if (onniRoot !== '/' && pfad.indexOf(onniRoot.toLowerCase()) === 0) {
        pfad = '/' + pfad.slice(onniRoot.length);
      }
      /* Locale-Praefix auch dann abwerfen, wenn der Link ihn nicht traegt (oder umgekehrt) */
      pfad = pfad.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/, '');
      return pfad.replace(/\/+$/, '') || '/';
    };
    const h_current = onniPfad(window.location.pathname);

    /* ONNI 09.09.2026: '/' steckt in jedem href und wuerde immer die erste Pille
       treffen. Ohne Unterseite gibt es keine aktive Pille. */
    let elem = null;
    if (h_current !== '/') {
      sub_container.querySelectorAll('a.onni-submenu-pills[href]').forEach(function (a) {
        if (elem) return;
        let ziel = null;
        try { ziel = new URL(a.getAttribute('href'), window.location.origin); } catch (e) { return; }
        if (onniPfad(ziel.pathname) === h_current) elem = a;
      });
      /* Sprungmarken auf derselben Seite (Bewertungen: #beste, #aktuell):
         steht ein Hash in der Adresse, gewinnt die Pille mit genau diesem Hash. */
      if (window.location.hash) {
        sub_container.querySelectorAll('a.onni-submenu-pills[href*="#"]').forEach(function (a) {
          let ziel = null;
          try { ziel = new URL(a.getAttribute('href'), window.location.origin); } catch (e) { return; }
          if (onniPfad(ziel.pathname) === h_current && ziel.hash === window.location.hash) elem = a;
        });
      }
      /* Klick auf eine Sprungmarke derselben Seite: selbst springen statt neu laden.
         Traegt die Adresse ?utm_... oder ?preview_theme_id, passt der Link ohne Query
         nicht zur aktuellen URL und der Browser laedt die Seite neu; danach setzt die
         eigene Scroll-Wiederherstellung (theme.liquid) auf 0 zurueck. Gemessen am Handy. */
      const onniSprung = function (hash, weich) {
        const el = hash && document.getElementById(hash.slice(1));
        if (!el) return false;
        el.scrollIntoView({ behavior: weich ? 'smooth' : 'auto', block: 'start' });
        return true;
      };
      sub_container.querySelectorAll('a.onni-submenu-pills[href*="#"]').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          let ziel = null;
          try { ziel = new URL(a.getAttribute('href'), window.location.origin); } catch (e) { return; }
          if (onniPfad(ziel.pathname) !== h_current) return;
          if (!onniSprung(ziel.hash, true)) return;
          ev.preventDefault();
          history.replaceState(history.state, '', window.location.pathname + window.location.search + ziel.hash);
          sub_container.querySelectorAll('a.sub_pills_current').forEach(function (b) { b.classList.remove('sub_pills_current'); });
          a.classList.add('sub_pills_current');
        });
      });
      /* Direkt mit #aktuell aufgerufen: nach dem Laden anspringen, falls die
         Scroll-Wiederherstellung die Seite oben gelassen hat. */
      if (window.location.hash && elem && elem.getAttribute('href').indexOf('#') !== -1) {
        window.addEventListener('load', function () {
          setTimeout(function () { if (window.scrollY < 50) onniSprung(window.location.hash, false); }, 200);
        });
      }
    }

    if (elem) {
        elem.classList.add("sub_pills_current");
    }

    /* Automatisch zum aktiven Pill scrollen nur auf Mobile (horizontale Scroll-Leiste) */
    if (document.documentElement.clientWidth < 750) {
      let scrollm = document.querySelector('a.sub_pills_current');
      if (scrollm) {
          /* ONNI 09.09.2026: bewusst kein scrollIntoView. Das scrollt neben der
             Leiste auch die ganze Seite, sobald die Leiste unter der Falz liegt
             (Befund Paavo an der Startseite). Nur den Container schieben. */
          const c = sub_container.getBoundingClientRect();
          const z = scrollm.getBoundingClientRect();
          const versatz = (z.left - c.left) - (c.width - z.width) / 2;
          sub_container.scrollTo({ left: sub_container.scrollLeft + versatz, behavior: "smooth" });
      }
    }

  }

  /* ONNI 09.09.2026: Der Rahmenlauf, der --onni-pills-top auf der Unterkante des
     Kopfbereichs hielt, ist entfallen. Er war nur noetig, solange die Leiste oben
     klebte und sonst vom wieder einfahrenden Kopfbereich verdeckt wurde. Ohne
     sticky gibt es nichts nachzufuehren — und ein Scroll-Zuhoerer weniger auf
     jeder Seite. */


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onni-submenu"] && !Shopify.designMode) return;
  try {
    

  const sub_container = document.querySelector('.onni-submenu-container');

if (sub_container && document.documentElement.clientWidth < 750) {

    const h_current = window.location.pathname+window.location.search;

    /* ONNI 09.09.2026 (Befund Paavo, Startseite iPhone): '/' steckt in JEDEM href.
       Auf der Startseite hat die Abfrage deshalb immer die erste Kachel getroffen
       und sie faelschlich als aktive Kategorie markiert. Dort gibt es keine
       aktive Kategorie, also gar nicht erst markieren. */
    let elem = null;
    if (h_current !== '/') {
        elem = sub_container.querySelector('a[href*="'+h_current+'"]');
    }

    if (elem) {
        elem.classList.add("sub_current");
    }

    let scrollm = document.querySelector('a.sub_current');
    if (scrollm) {
        onniLeisteWaagerechtZentrieren(sub_container, scrollm);
    }

  }

  /* ONNI 09.09.2026: NICHT scrollIntoView benutzen. Die Leiste soll nur waagerecht
     zur aktiven Kachel rutschen, aber scrollIntoView scrollt zusaetzlich die ganze
     SEITE, sobald die Leiste unter der Falz liegt. Auf der Startseite sitzt sie bei
     1024 px und die Seite sprang beim Laden auf scrollY 500. Wir schieben deshalb
     nur den Container selbst. Gleiche Lehre wie in onni-collection-swap.js. */
  function onniLeisteWaagerechtZentrieren(container, ziel) {
    const c = container.getBoundingClientRect();
    const z = ziel.getBoundingClientRect();
    const versatz = (z.left - c.left) - (c.width - z.width) / 2;
    container.scrollTo({ left: container.scrollLeft + versatz, behavior: "smooth" });
  }

  // if (window.location.search) {



  } catch(e) { console.error(e); }
})();
})();
